"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSwitcher = void 0;
var vue_1 = require("vue");
var constants_1 = require("../constants");
var PreferencesManager_1 = require("./PreferencesManager");
exports.LanguageSwitcher = vue_1.default.component('language-switcher', {
    data: function () {
        return {
            'languages': constants_1.LANGUAGES,
        };
    },
    methods: {
        switchLanguageTo: function (langId, reloadThePage) {
            if (reloadThePage === void 0) { reloadThePage = false; }
            PreferencesManager_1.PreferencesManager.save('lang', langId);
            if (reloadThePage)
                window.location = window.location;
        },
    },
    template: "\n        <div class=\"language-switcher\">\n            <div\n                v-for=\"lang in languages\"\n                :class=\"'language-icon language-icon--'+lang.id\"\n                :title=\"lang.title\"\n                v-on:click=\"switchLanguageTo(lang.id, true)\"></div>\n        </div>\n    ",
});
//# sourceMappingURL=LanguageSwitcher.js.map